import React, { useState } from "react";
import { useParams } from "react-router-dom";

import { useAppDispatch } from "../../../app/hooks";
import ManagementModal from "../../../components/ui/modals/ManagementModal";
import AssetForm from "./AssetForm";

import {AssetFields} from "../../../api/assets";

import { createAsset } from "../Logic/assetsThunk";

import {showErrorToast,showSuccessToast} from "../../../lib/toast";

interface AddAssetModalProps {
  onClose: () => void;
  onBack: () => void;
  onSuccess?: (newAssetId: string) => void;
}

const AddAssetModal: React.FC<
  AddAssetModalProps
> = ({
  onClose,
  onBack,
  onSuccess
}) => {
  const dispatch = useAppDispatch();

  const { id: caseId } = useParams<{ id: string }>();

  const [isSaving, setIsSaving] =
    useState(false);

  const [values, setValues] =useState<Partial<AssetFields>>({
      asset_class: undefined,
      asset_type: undefined,
      ext_asset_id: "",
      asset_name: "",
    });

  const handleCancel = () => {
    setValues({
      asset_class: undefined,
      asset_type: undefined,
      ext_asset_id: "",
      asset_name: "",
    });

    onClose();
  };

  const handleSubmit = async () => {
    if (!caseId) {
      showErrorToast("Case ID not found");
      return;
    }

    setIsSaving(true);

    try {
      const result = await dispatch(
        createAsset({
          case_id: caseId,
          request: values as AssetFields,
        }),
      ).unwrap();

      showSuccessToast("Asset created successfully");

      if (onSuccess && result?.asset_id) {
        onSuccess(result.asset_id);
      }

      onClose();
    } catch (error) {
      showErrorToast("Failed to create asset. Please try again!");
    } finally {
      setIsSaving(false);
    }
  };

  const isSubmitEnabled =
    !!values.asset_class &&
    !!values.asset_type &&
    !!values.ext_asset_id?.trim() &&
    !isSaving;  

  return (
    <ManagementModal
      title="Add Asset"
      submitLabel="Add Asset"
      onSubmit={handleSubmit}
      onCancel={handleCancel}
      onBack={onBack}
      onClose={onClose}
      submitEnabled={isSubmitEnabled}
      isLoading={isSaving}
    >
      <AssetForm
        values={values}
        onValuesChange={setValues}
      />
    </ManagementModal>
  );
};

export default AddAssetModal;